import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { GkComponentsModule, GkMapModule } from "@gk/gk-modules";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared/shared.module";
import { createTranslateLoader } from "../address-number-request-portal/address-number-request-portal.module";
import { MonumentInstallationRequestRoutingModule } from "./monument-installation-request-routing.module";
import { MonumentInstallationRequestComponent } from "./monument-installation-request.component";
import { MIRNewRequestComponent } from "./new-request/new-request.component";
import { MIRNewRequestFormService } from "./services/new-request-form/new-request-form.service";

@NgModule({
  declarations: [MonumentInstallationRequestComponent, MIRNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    MonumentInstallationRequestRoutingModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  providers: [MIRNewRequestFormService],
})
export class MonumentInstallationRequestModule {}
